export default __webpack_public_path__ + "static/media/HDTX_Minutes Summary of AGMS of June 2023.2d81208b.pdf";